import React from 'react';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import FlatpickrWrapper from './FlatpickrWrapper';

const DatePicker = ({
  value,
  onChange,
  size = 1,
  mode = 'range',
  minDate,
  maxDate,
}) => {
  return (
    <FlatpickrWrapper size={size}>
      <Flatpickr
        options={{
          mode,
          monthSelectorType: 'static',
          inline: true,
          minDate,
          maxDate,
        }}
        onChange={onChange}
        value={value}
      />
    </FlatpickrWrapper>
  );
};

DatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  size: PropTypes.any,
  mode: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default DatePicker;
